var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 33.994,
    viewBox: "0 0 34 33.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 34,
    height: 33.994,
    fill: "#a7a7a7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    transform: "translate(-520.104 -424.08)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    transform: "translate(520.104 424.08)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M14.565,0h10.7a3.649,3.649,0,0,1,3.878,3.867q0,7.114,0,14.228a1.213,1.213,0,0,1-1.611,1.256,1.175,1.175,0,0,1-.813-1.085c-.013-.176,0-.354,0-.531q0-6.924,0-13.849c0-1.007-.451-1.459-1.455-1.459H3.9c-1.019,0-1.467.441-1.467,1.445q0,10.7,0,21.4A1.256,1.256,0,0,0,3.867,26.71q7.115,0,14.23,0a1.217,1.217,0,1,1,.023,2.426q-2.941,0-5.882,0-4.193,0-8.386,0A3.65,3.65,0,0,1,0,25.282Q0,14.564,0,3.845A3.65,3.65,0,0,1,3.864,0q5.351,0,10.7,0",
    transform: "translate(0 0)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M67.375,121.213H47.967v-.388c0-2.339,0-4.677-.006-7.016a.779.779,0,0,1,.263-.625c.431-.409.838-.842,1.261-1.26a1.2,1.2,0,0,1,1.813-.009c.461.451.912.912,1.367,1.369l1.364,1.375c.11-.1.209-.195.3-.29l5.977-5.984a1.244,1.244,0,0,1,2.029,0q2.413,2.414,4.819,4.836a.731.731,0,0,1,.229.438c.014,2.465.01,4.93.008,7.395a1.445,1.445,0,0,1-.019.162",
    transform: "translate(-43.109 -96.95)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M220.946,220.9v-1.693c0-.632-.005-1.264,0-1.9a1.213,1.213,0,1,1,2.425-.014c.008,1.049,0,2.1,0,3.147v.455h.658c.973,0,1.947,0,2.92,0a1.214,1.214,0,1,1,0,2.425c-1.174.006-2.348,0-3.574,0v.422c0,1.036,0,2.073,0,3.109a1.218,1.218,0,1,1-2.427.012c0-1.162,0-2.324,0-3.543h-.414c-1.037,0-2.073,0-3.11,0a1.219,1.219,0,1,1,.007-2.427c1.037,0,2.073,0,3.11,0h.407",
    transform: "translate(-194.231 -194.194)",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M84.11,51.069a3.035,3.035,0,1,1-3.03-3.047,3.04,3.04,0,0,1,3.03,3.047",
    transform: "translate(-70.146 -43.164)",
    fill: "#a7a7a7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.65a4e69a63bbcb07abd3aaf78acd5501.svg";
export { ForwardRef as ReactComponent };